/**
 * Dashboard Service
 * Handles dashboard statistics and data fetching
 */

import { api } from '../lib/axios';

export interface DashboardStats {
  totalProducts: number;
  totalBatches: number;
  totalUsers: number;
  pendingApprovals: number;
  recentActivity: ActivityItem[];
  packagingAnalytics?: {
    transfersByLevel?: {
      unit: number;
      case: number;
      pallet: number;
    };
    bulkTransferPercentage?: number;
  };
}

export interface ActivityItem {
  id: string;
  type: 'batch_created' | 'user_approved' | 'product_transferred' | 'product_consumed';
  description: string;
  timestamp: string;
  user?: string;
}

class DashboardService {
  /**
   * Get dashboard statistics for manufacturer
   */
  async getStats(): Promise<DashboardStats> {
    const response = await api.get('/dashboard/stats');
    return response.data.data;
  }

  /**
   * Get recent activity
   */
  async getRecentActivity(limit: number = 10): Promise<ActivityItem[]> {
    const response = await api.get('/dashboard/activity', {
      params: { limit }
    });
    return response.data.data;
  }
}

export const dashboardService = new DashboardService();
